<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
        <button class="btn btn-outline-success" (click)="onNext()" title="Aceptar">Aceptar</button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <h4>Nueva Solicitud</h4>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedTipos = !isCollapsedTipos" [attr.aria-expanded]="!isCollapsedTipos" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Tipo de Solicitud
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="row">
                            <div class="col-md-6 collapse group-campos" id="collapseTipos" [ngbCollapse]="isCollapsedTipos">

                                <div class="ui-g">

                                    <!--COMUNIDAD AUTONOMA-->
                                    <div class="ui-g-12">
                                        <p-radioButton formControlName="tipoSolicitudAtestFito" (click)="onSelectedTipoSolicitudAtestFito()" inputStyleClass="form-control" name="tipoSolicitudAtestFito" value="CA" label="Comunidad Autónoma"></p-radioButton>
                                    </div>
                                    <!--AGENTE DE CONTROL-->
                                    <div class="ui-g-12">
                                        <p-radioButton formControlName="tipoSolicitudAtestFito" (click)="onSelectedTipoSolicitudAtestFito()" inputStyleClass="form-control" name="tipoSolicitudAtestFito" value="AC" label="Agente de Control"></p-radioButton>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div *ngIf="form.value.tipoSolicitudAtestFito === 'CA' || form.value.tipoSolicitudAtestFito === 'AC'">                    
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDatos = !isCollapsedDatos" [attr.aria-expanded]="!isCollapsedDatos" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Datos adicionales
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-campos" id="collapsedDatos" [ngbCollapse]="isCollapsedDatos">
                                <div class="row">

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label required-field" for="intEstado">Comunidad Autónoma</label>
                                        <ng-select [items]="listComunidad"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdCa"
                                                   loadingText="Cargando..."
                                                   [loading]="!listComunidad"
                                                   notFoundText="Comunidad Autónoma no encontrada"
                                                   placeholder="-- Seleccione una Comunidad Autónoma --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdCa')"
                                                   (change)="onSelectComunidad()">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCa','required')">
                                            Comunidad Autónoma es obligatoria
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="intEstado">Agente de Control</label>
                                        <ng-select [items]="listAgenteControl"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdAc"
                                                   loadingText="Cargando..."
                                                   [loading]="!listAgenteControl && (form.value.IdCa > 0)"
                                                   notFoundText="Agente de Control no encontrado"
                                                   placeholder="-- Seleccione un Agente de Control --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdAc')">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdAc','required')">
                                            Agente de Control es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label required-field" for="intProvincia">Provincia</label>
                                        <ng-select loadingText="Cargando..."
                                                   [items]="listProvincia"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdProvincia"
                                                   [loading]="!listProvincia && (form.value.IdCa > 0)"
                                                   notFoundText="Provincia no encontrada"
                                                   placeholder="-- Seleccione una Provincia --"
                                                   [ngClass]="displayFieldCssNgSelect('IdProvincia')"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdProvincia','required')">
                                            Provincia es obligatoria
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label required-field" for="inpPais">País Destino</label>
                                        <ng-select [items]="listPais"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdPaisDestino"
                                                   loadingText="Cargando..."
                                                   [loading]="!listPais"
                                                   notFoundText="País no encontrado"
                                                   placeholder="-- Seleccione un País --"
                                                   [ngClass]="displayFieldCssNgSelect('IdPaisDestino')"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>


                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisDestino','required')">
                                            País es obligatorio
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card-body-detalle">
                    Seleccione el tipo de solicitud y pulse el botón de "Aceptar"                    
                </div>

            </div>
        </div>
    </div>

</form>
